import React from "react";
import {
  Tabs,
  Tab,
} from "@heroui/react";

import CustomerSettingsList from "./CustomerSettingsList";
import CustomerGroupSettingsList from "./CustomerGroupSettingsList";
import { useStyles } from "@/hooks/useStyles";

import { useTranslation } from "react-i18next";
import { FaBuildingUser } from "react-icons/fa6";

export default function Customers() {
  const { t } = useTranslation();
  const styles = useStyles();
  const [selected, setSelected] = React.useState("customer_settings");
  
  return (
    <>
      <div className="w-full text-vistagrey my-6 inline-flex">
        <div>
          <div className="text-vistagrey text-xl">
            <FaBuildingUser className="fill-vistagreen inline-block text-4xl mr-2" />
            {t("customers")}
          </div>
          <div className="text-sm pl-11 -mt-2">{t("customer_management")}</div>
        </div>
      </div>

      <div className="relative w-full">
        <Tabs
          aria-label={t("customers")}
          selectedKey={selected}
          onSelectionChange={(key) => setSelected(String(key))} 
          variant="underlined"
          classNames={styles}
        >
          <Tab
            key="customer_settings"
            title={
              <div className="flex items-center space-x-2">
                <span>{t("customer_settings")}</span>
              </div>
            }
          >
            <CustomerSettingsList />
          </Tab>

          <Tab
            key="customer_group_settings"
            title={
              <div className="flex items-center space-x-2">
                <span>{t("customer_group_settings")}</span>
              </div>
            }
          >
            <CustomerGroupSettingsList />
          </Tab>
        </Tabs>
      </div>
      
    </>
  );
}